import { Col, Container, Row } from 'react-bootstrap';
import user1 from "../../assets/user_images/user7.jpg";
import user2 from "../../assets/user_images/user8.jpg";
import user3 from "../../assets/user_images/user9.jpg";
import user4 from "../../assets/user_images/user10.jpg";

const teamData = [
    {
        id: 1,
        name: 'David Wilson',
        position: 'SEO Director',
        image: user1,
        social: {
            linkedin: '#',
            instagram: '#',
            twitter: '#'
        }
    },
    {
        id: 2,
        name: 'Jessica Lee',
        position: 'PPC Specialist',
        image: user2,
        social: {
            linkedin: '#',
            instagram: '#',
            twitter: '#'
        }
    },
    {
        id: 3,
        name: 'Robert Kim',
        position: 'Social Media Manager',
        image: user3,
        social: {
            linkedin: '#',
            instagram: '#',
            twitter: '#'
        }
    },
    {
        id: 4,
        name: 'Amanda Patel',
        position: 'Content Strategist',
        image: user4,
        social: {
            linkedin: '#',
            instagram: '#',
            twitter: '#'
        }
    }
]

const Experts = () => {
    return (
        <section className='section-lg bg-light'>
            <Container>
                <Row className='text-center mb-5'>
                    <Col lg={8} className="mx-auto text-center">
                        <div className="service-heading mb-3">
                            <h6 className="underline-after text-center position-relative z-0">
                                <span className="position-relative z-1 bg-white text-primary px-3">Our Experts</span>
                            </h6>
                            <h2 className="d-block text-gradiant text-center fw-semibold display-5">Meet Our Digital Marketing Team</h2>
                        </div>
                        <p className="lead text-secondary">Our team of experienced professionals is dedicated to helping your business succeed online.</p>
                    </Col>
                </Row>
                <Row className="g-4 team-section">
                    {teamData.map((member) => (
                        <Col lg={3} md={6} key={member.id}>
                            <div className="team-card card border-0 shadow-sm h-100 overflow-hidden">
                                <div className="team-image position-relative">
                                    <img src={member.image} className="card-img-top" alt={member.name} />
                                    <div className="team-overlay d-flex justify-content-center align-items-center gap-2 position-absolute top-0 start-0 w-100 h-100">
                                        <a href={member.social.linkedin} className="socialContainer linkedin-icon overflow-hidden">
                                            <div className="icon">
                                                <i className="ri-linkedin-fill"></i>
                                            </div>
                                        </a>
                                        <a href={member.social.instagram} className="socialContainer insta-icon overflow-hidden">
                                            <div className="icon">
                                                <i className="ri-instagram-fill"></i>
                                            </div>
                                        </a>
                                        <a href={member.social.twitter} className="socialContainer twitter-icon overflow-hidden">
                                            <div className="icon">
                                                <i className="ri-twitter-fill"></i>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="card-body p-4 text-center">
                                    <h5 className="fw-semibold mb-1">{member.name}</h5>
                                    <p className="text-secondary mb-0">{member.position}</p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default Experts;
